var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"","visible":_vm.show,"width":"1600px","top":"2vh"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('iframe',{staticStyle:{"width":"1560px","height":"920px"},attrs:{"src":"http://120.26.202.178:10035/CFCM/#/cucumber/index","frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176c1636","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome/LandGuideFertilizerDialog.vue
// module id = null
// module chunks = 